import api from './axios';

export const fetchAdminStats = () => api.get('/admin/stats').then((r) => r.data);

export const fetchPendingTenants = () => api.get('/admin/tenants/pending').then((r) => r.data);

export const fetchRecentActivity = () => api.get('/admin/activity/recent').then((r) => r.data);

export const fetchTenants = (params) =>
  api.get('/admin/tenants', { params }).then((r) => r.data);

export const fetchTenant = (tenantId) =>
  api.get(`/admin/tenants/${tenantId}`).then((r) => r.data);

export const approveTenant = (tenantId) =>
  api.put(`/admin/tenants/${tenantId}/approve`).then((r) => r.data);

export const rejectTenant = (tenantId, rejectionReason) =>
  api.put(`/admin/tenants/${tenantId}/reject`, { rejectionReason }).then((r) => r.data);

export const suspendTenant = (tenantId, reason) =>
  api.put(`/admin/tenants/${tenantId}/suspend`, { reason }).then((r) => r.data);

export const cancelTenant = (tenantId) =>
  api.put(`/admin/tenants/${tenantId}/cancel`).then((r) => r.data);

export const reactivateTenant = (tenantId) =>
  api.put(`/admin/tenants/${tenantId}/reactivate`).then((r) => r.data);

export const impersonateTenant = (tenantId) =>
  api.post(`/admin/tenants/${tenantId}/impersonate`).then((r) => r.data);

export const fetchUsers = (params) =>
  api.get('/admin/users', { params }).then((r) => r.data);

export const createSuperAdmin = (body) =>
  api.post('/admin/users/super-admins', body).then((r) => r.data);

export const toggleUserActive = (userId) =>
  api.put(`/admin/users/${userId}/toggle-active`).then((r) => r.data);

export const resetUserPassword = (userId, body) =>
  api.put(`/admin/users/${userId}/reset-password`, body).then((r) => r.data);

export const fetchActivityLogs = (params) =>
  api.get('/admin/activity-logs', { params }).then((r) => r.data);

export const fetchPendingStaffRegistrations = (params) =>
  api.get('/admin/staff-registrations/pending', { params }).then((r) => r.data);

export const approveAdminStaffRegistration = (permissionId) =>
  api.post(`/admin/staff-registrations/${permissionId}/approve`).then((r) => r.data);

export const rejectAdminStaffRegistration = (permissionId) =>
  api.post(`/admin/staff-registrations/${permissionId}/reject`).then((r) => r.data);
